export default "__VITE_ASSET__BI3hQRli__"